module.exports = __webpack_public_path__ + "static/ads-4e5d86a948d3a147384c24074c3a76c1.jpg";